// extracted by mini-css-extract-plugin
export var arrowContainer = "recipes-related-recipes-module--arrow-container--c73d6";
export var arrowContainerRight = "recipes-related-recipes-module--arrow-container-right--c4b2e";
export var articleCards = "recipes-related-recipes-module--article-cards--91a04";
export var article_container = "recipes-related-recipes-module--article_container--bbf09";
export var bar = "recipes-related-recipes-module--bar--d7155";
export var displayNavigation = "recipes-related-recipes-module--display-navigation--9951d";
export var featuredArticleTitle = "recipes-related-recipes-module--featured-article-title--28057";
export var icon = "recipes-related-recipes-module--icon--8b56f";
export var img_wrapper = "recipes-related-recipes-module--img_wrapper--5a032";
export var mainImg = "recipes-related-recipes-module--mainImg--b9318";
export var nextButton = "recipes-related-recipes-module--next-button--57a39";
export var prevButton = "recipes-related-recipes-module--prev-button--cdbf1";
export var swiperContainer = "recipes-related-recipes-module--swiper-container--1d684";
export var triangle_wrapper = "recipes-related-recipes-module--triangle_wrapper--68bde";
export var triangle_wrapper_left = "recipes-related-recipes-module--triangle_wrapper_left--6add1";
export var triangle_wrapper_right = "recipes-related-recipes-module--triangle_wrapper_right--241c2";